<template>
  <div id="app">
    <router-view />
    <loader :is-visible="isLoading" text="Loading..."></loader>
    <processing :is-visible="isProcessing"></processing>
    <MessageBox ref="MessageBox"></MessageBox>
    <FlashMessage ref="FlashMessage"></FlashMessage>
  </div>
</template>

<script>
import vue from "vue";
import axios from "axios";
import loader from "./components/Loader";
import processing from "./components/ekkControls/Processing";
import MessageBox from "./components/ekkControls/MessageBox";
import FlashMessage from "./components/ekkControls/FlashMessage";
import config from "@/router/globalConfig";
vue.use(loader);
export default {
  name: "App",
  components: {
    loader: loader,
    processing: processing,
    MessageBox: MessageBox,
    FlashMessage: FlashMessage,
  },
  data() {
    return {
      axiosInterceptor: null,
      isLoading: false,
      isProcessing: false,
    };
  },
  created() {
    this.enableInterceptor();
  },
  mounted() {
    window.MessageBox = this.$refs.MessageBox;
    window.FlashMessage = this.$refs.FlashMessage;
  },
  methods: {
    enableInterceptor() {
      let isRefreshing = false;
      let isSessionExp = false;
      let failedUrl = [];
      let failedQueue = [];
      this.axiosInterceptor = axios.interceptors.request.use(
        (config) => {
          this.isLoading = true;
          return config;
        },
        (error) => {
          this.isLoading = false;
          return Promise.reject(error);
        }
      );
      axios.interceptors.response.use(
        (response) => {
          this.isProcessing = true;
          this.isLoading = false;
          return response;
        },
        (error) => {
          let me = this;
          if (error != null && error.response != undefined) {
            if (
              error.response.status == 401 &&
              error.response.config.url.toLowerCase().indexOf("logedme") ==
                -1 &&
              error.response.config.url.toLowerCase().indexOf("refreshme") ==
                -1 &&
              error.response.config.url.toLowerCase().indexOf("token") == -1
            ) {
              const originalRequest = error.config;

              if (isRefreshing) {
                me.isLoading = false;
                if (isSessionExp) {
                  me.isLoading = false;
                  this.$router.push({ name: "SessionExpire" }).catch(() => {});
                  return Promise.reject();
                } else {
                  originalRequest.headers.Authorization = config.LOG_Token;
                  //return Promise.resolve(axios(originalRequest));
                  //return Promise.resolve(axios(originalRequest));
                  return new Promise((resolve, reject) => {
                    setTimeout(function () {
                      resolve(axios(originalRequest));
                    }, 1000);
                  });
                }
              }

              if (isSessionExp) {
                this.isLoading = false;
                this.$router.push({ name: "SessionExpire" }).catch(() => {});
                return Promise.reject();
              }
              isRefreshing = true;

              //alert("call Refresh");
              let rft = window.sessionStorage.getItem("refresh_token");
              const params =
                "refresh_token=" +
                encodeURIComponent(rft) +
                "&grant_type=refresh_token";
              //axios.interceptors.response.eject(interceptor);

              return axios
                .post(config.WEB_TOKEN_PATH, params, {
                  headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                  },
                  crossdomain: true,
                })
                .then(
                  (result) => {
                    //alert(JSON.stringify(result));
                    const tokenData = result.data;
                    window.sessionStorage.setItem(
                      "token",
                      tokenData.access_token
                    );
                    window.sessionStorage.setItem(
                      "token_type",
                      tokenData.token_type
                    );
                    window.sessionStorage.setItem(
                      "refresh_token",
                      tokenData.refresh_token
                    );
                    window.sessionStorage.setItem(
                      "antiforgery_token",
                      tokenData.antiforgery_token
                    );
                    config.LOG_Token = "bearer ".concat(
                      window.sessionStorage.getItem("token")
                    );
                    config.AF_Token =
                      window.sessionStorage.getItem("antiforgery_token");
                    me.isLoading = false;
                    //return axios(originalRequest);
                    originalRequest.headers.Authorization = config.LOG_Token;
                    originalRequest.baseURL = undefined;
                    isSessionExp = false;
                    return new Promise((resolve, reject) => {
                      resolve(axios(originalRequest));
                    });
                  },
                  (error) => {
                    if (error.response == undefined) {
                      // console.log("Error: " + error);
                    }

                    //else {
                    //   if (error.response.status == "401") {
                    //     //alert(error.response.data);
                    //   }
                    // }

                    window.sessionStorage.removeItem("token");
                    window.sessionStorage.removeItem("token_type");
                    window.sessionStorage.removeItem("refresh_token");
                    me.isLoading = false;

                    isSessionExp = true;
                    this.$router
                      .push({ name: "SessionExpire" })
                      .catch(() => {});
                    return Promise.reject();
                  },
                  (failure) => {
                    // console.log("Failure: " + failure);
                  }
                )
                .catch(function (error) {
                  isRefreshing = false;
                  isSessionExp = false;
                  return Promise.reject();
                })
                .finally(function (error) {
                  isRefreshing = false;
                  isSessionExp = false;
                  //return Promise.reject();
                });
              //return axios(originalRequest);
            } else {
              me.isLoading = false;
              if (
                error.response != undefined &&
                (error.response.statusText == "SessionExpire" ||
                  error.response.statusText == "invalid_grant")
              ) {
                window.sessionStorage.removeItem("token");
                window.sessionStorage.removeItem("token_type");
                window.sessionStorage.removeItem("refresh_token");

                isSessionExp = true;
                this.$router.push({ name: "SessionExpire" }).catch(() => {});
                return Promise.reject();
              } else if (
                error.response != undefined &&
                error.response.statusText == "invalid_license"
              ) {
                this.$router.push({ name: "License" }).catch(() => {});
                return Promise.reject();
              } else {
                let error_msg;
                let status = -111;
                if (error.response == undefined) {
                  error_msg = error.message;
                } else {
                  status = error.response.status;
                  error_msg = error.response.data;
                }
                if (status == 587) {
                  return Promise.reject(error);
                } else {
                  window.MessageBox.show({
                    message: error_msg,
                    type: "error",
                    title: "Message",
                  });
                  return Promise.reject();
                }
              }
            }
          } else {
            me.isLoading = false;
            let error_msg;
            if (error.response == undefined) {
              error_msg = error.message;
            } else {
              error_msg = error.response;
            }
            window.MessageBox.show({
              message: error_msg,
              type: "error",
              title: "Message",
            });
            return Promise.reject();
          }
        }
      );
    },
    disableInterceptor() {
      axios.interceptors.request.eject(this.axiosInterceptor);
    },
  },
};
</script>

<style>
@import url("./assets/css/Theme/main_v1.0.css");
@import url("./assets/css/Theme/Desktop_v1.0.css");
@import url("./assets/css/Theme/Mobile_Landscape_v1.0.css");
@import url("./assets/css/Theme/Mobile_Portrait_v1.0.css");
@import url("./assets/css/Theme/ThemeColor_v1.0.css");
@import url("./assets/css/Theme/AAADTheme.css");
@import url("./assets/fonts/glyphicons.css");
@import url("./assets/fonts/font-awesome.css");
#app {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue